export default __webpack_public_path__ + "static/media/configr-custom-negative.b91e1ab4.svg";